import { render } from "./FAQ-form-modal.vue?vue&type=template&id=059bfbbe"
import script from "./FAQ-form-modal.vue?vue&type=script&lang=js"
export * from "./FAQ-form-modal.vue?vue&type=script&lang=js"

import "./FAQ-form-modal.vue?vue&type=style&index=0&id=059bfbbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__